import type { QueryClient } from "@tanstack/react-query";
import { invalidateBalanceQueries } from "@/features/balance/utils/invalidate-balance-queries";
import { QueryKeys } from "@/lib/types";

/** Student statement, balances, and Current Tuition after Post Tuition syncs. */
export async function invalidatePostedTuitionLedgerQueries(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    invalidateBalanceQueries(queryClient),
    queryClient.invalidateQueries({
      queryKey: [QueryKeys.TuitionPreview],
      refetchType: "all",
    }),
  ]);
}
